"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _validations = require("../../utils/validations");
var _commonUtils = require("../../utils/commonUtils");
var _constants = require("../../constants/constants");
var _fieldsMessages = require("./fieldsMessages");
var _fieldErrorIcon = _interopRequireDefault(require("./errors/fieldErrorIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var NameField = function NameField(_ref) {
  var block = _ref.block,
    inputRef = _ref.inputRef;
  var _useIntl = (0, _reactIntl.useIntl)(),
    formatMessage = _useIntl.formatMessage;
  var labelStrings = block.strings || {};
  var firstNameLabel = (0, _commonUtils.getCustomOrDefaultValue)(labelStrings.firstNameLabel, formatMessage(_fieldsMessages.fieldsMessages.firstNameLabel));
  var lastNameLabel = (0, _commonUtils.getCustomOrDefaultValue)(labelStrings.lastNameLabel, formatMessage(_fieldsMessages.fieldsMessages.lastNameLabel));
  var firstNamePlaceholder = (0, _commonUtils.getCustomOrDefaultValue)(labelStrings.firstNamePlaceholder, formatMessage(_fieldsMessages.fieldsMessages.firstNamePlaceholder));
  var lastNamePlaceholder = (0, _commonUtils.getCustomOrDefaultValue)(labelStrings.lastNamePlaceholder, formatMessage(_fieldsMessages.fieldsMessages.lastNamePlaceholder));
  var _ref2 = labelStrings.errorMessages || {},
    isFirstNameEmptyMessage = _ref2.isFirstNameEmptyMessage,
    isFirstNameMaxMessage = _ref2.isFirstNameMaxMessage,
    isFirstNameInvalidMessage = _ref2.isFirstNameInvalidMessage,
    isLastNameEmptyMessage = _ref2.isLastNameEmptyMessage,
    isLastNameInvalidMessage = _ref2.isLastNameInvalidMessage,
    isLastNameMaxMessage = _ref2.isLastNameMaxMessage;
  var _ref3 = block.maxLimit || {},
    firstNameLimit = _ref3.firstNameLimit,
    lastNameLimit = _ref3.lastNameLimit;
  var customFirstName = (0, _commonUtils.getCustomOrDefaultValue)(block.value && block.value.firstName, '');
  var customSecondName = (0, _commonUtils.getCustomOrDefaultValue)(block.value && block.value.lastName, '');

  // internationalize all the error messages
  block = _objectSpread(_objectSpread({}, block), {}, {
    isFirstNameEmptyMessage: isFirstNameEmptyMessage || formatMessage(_fieldsMessages.fieldsErrorMessages.incompleteField),
    isLastNameEmptyMessage: isLastNameEmptyMessage || formatMessage(_fieldsMessages.fieldsErrorMessages.incompleteField),
    isFirstNameMaxMessage: isFirstNameMaxMessage || formatMessage(_fieldsMessages.fieldsErrorMessages.exceedsMaxChracters, {
      max: _constants.FIRST_NAME_FIELD_MAX
    }),
    isLastNameMaxMessage: isLastNameMaxMessage || formatMessage(_fieldsMessages.fieldsErrorMessages.exceedsMaxChracters, {
      max: _constants.LAST_NAME_FIELD_MAX
    }),
    firstNameLimit: firstNameLimit || _constants.FIRST_NAME_FIELD_MAX,
    lastNameLimit: lastNameLimit || _constants.LAST_NAME_FIELD_MAX,
    isFirstNameInvalidMessage: isFirstNameInvalidMessage || formatMessage(_fieldsMessages.fieldsErrorMessages.invalidFirstName),
    isLastNameInvalidMessage: isLastNameInvalidMessage || formatMessage(_fieldsMessages.fieldsErrorMessages.invalidLastName)
  });
  var _useState = (0, _react.useState)(customFirstName),
    _useState2 = _slicedToArray(_useState, 2),
    firstNameValue = _useState2[0],
    setFirstNameValue = _useState2[1];
  var _useState3 = (0, _react.useState)(customSecondName),
    _useState4 = _slicedToArray(_useState3, 2),
    lastNameValue = _useState4[0],
    setLastNameValue = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    firstNameFieldError = _useState6[0],
    setFirstNameFieldError = _useState6[1];
  var _useState7 = (0, _react.useState)(''),
    _useState8 = _slicedToArray(_useState7, 2),
    lastNameFieldError = _useState8[0],
    setlastNameFieldError = _useState8[1];
  var handleChange = function handleChange(e, field) {
    var value = e.target.value;
    if (field === 'first') {
      var validationMessage = _validations.defaultFieldValidators.firstNameField(block, value);
      validationMessage ? setFirstNameFieldError(validationMessage) : setFirstNameFieldError('');
      setFirstNameValue(value);
    } else {
      var _validationMessage = _validations.defaultFieldValidators.lastNameField(block, value);
      _validationMessage ? setlastNameFieldError(_validationMessage) : setlastNameFieldError('');
      setLastNameValue(value);
    }
  };
  var firstNameField = /*#__PURE__*/_react.default.createElement("div", {
    className: "payment-widget__checkout__first-name__container"
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "payment-widget__checkout__first-name",
    className: "payment-checkout__label"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'payment-checkout__label__text ' + (firstNameFieldError.length > 0 ? 'payment-checkout__label__text--error' : '')
  }, firstNameLabel)), /*#__PURE__*/_react.default.createElement("div", {
    className: "payment-checkout__input-wrapper"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "text",
    placeholder: firstNamePlaceholder,
    className: 'payment-widget__checkout__name-field ' + (firstNameFieldError.length ? 'payment-widget__checkout__fields__input__error' : ''),
    name: "payment-widget__checkout__first-name",
    id: "payment-widget__checkout__first-name",
    "aria-describedby": "error-first-name",
    onChange: function onChange(e) {
      return handleChange(e, 'first');
    },
    onBlur: function onBlur(e) {
      return handleChange(e, 'first');
    },
    value: firstNameValue,
    autoComplete: "name given-name",
    required: true
  }), firstNameFieldError.length > 0 && /*#__PURE__*/_react.default.createElement(_fieldErrorIcon.default, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "payment-widget__checkout__name-field__error payment-widget__checkout__field__error",
    id: "error-first-name",
    "aria-live": "assertive",
    role: "status"
  }, firstNameFieldError));
  var lastNameField = /*#__PURE__*/_react.default.createElement("div", {
    className: "payment-widget__checkout__last-name__container"
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "payment-widget__checkout__last-name",
    className: "payment-checkout__label"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'payment-checkout__label__text ' + (lastNameFieldError.length > 0 ? 'payment-checkout__label__text--error' : '')
  }, lastNameLabel)), /*#__PURE__*/_react.default.createElement("div", {
    className: "payment-checkout__input-wrapper"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "text",
    placeholder: lastNamePlaceholder,
    className: 'payment-widget__checkout__name-field ' + (lastNameFieldError.length ? 'payment-widget__checkout__fields__input__error' : ''),
    name: "payment-widget__checkout__last-name",
    id: "payment-widget__checkout__last-name",
    "aria-describedby": "error-last-name",
    onChange: function onChange(e) {
      return handleChange(e, 'last');
    },
    onBlur: function onBlur(e) {
      return handleChange(e, 'last');
    },
    value: lastNameValue,
    autoComplete: "name family-name",
    required: true
  }), lastNameFieldError.length > 0 && /*#__PURE__*/_react.default.createElement(_fieldErrorIcon.default, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "payment-widget__checkout__name-field__error payment-widget__checkout__field__error",
    id: "error-last-name",
    "aria-live": "assertive",
    role: "status"
  }, lastNameFieldError));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "payment-widget__checkout__name-field__container",
    ref: inputRef
  }, firstNameField, lastNameField);
};
NameField.propTypes = {
  block: _propTypes.default.object.isRequired,
  inputRef: _propTypes.default.func.isRequired
};
var _default = NameField;
exports.default = _default;